/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import espInfo, { EspKey } from 'cio/utils/email-service-providers';

import AccountService from 'cio/services/account';

interface CreateServerModalSetupWebhooksStepArgs {
  selectedEsp: EspKey;
  onClose: () => unknown;
  onGoBack: () => unknown;
  onSkipWebhookSetup: () => unknown;
  onConfirmWebhookSetup: () => unknown;
}

export default class CreateServerModalSetupWebhooksStep extends Component<CreateServerModalSetupWebhooksStepArgs> {
  @service account!: AccountService;

  readonly EspKey = EspKey;

  get dataCenter() {
    return this.account.current.dataCenter;
  }
  get selectedEspInfo() {
    return espInfo(this.args.selectedEsp);
  }
  get webhookTrackingUrl() {
    return this.selectedEspInfo.webhookTrackingUrl?.[this.dataCenter];
  }
  get bouncePostbackUrl() {
    return this.selectedEspInfo.bouncePostbackUrl?.[this.dataCenter];
  }
  get spamComplaintPostbackUrl() {
    return this.selectedEspInfo.spamComplaintPostbackUrl?.[this.dataCenter];
  }
}
